import { createQueryKeys, mergeQueryKeys } from "@lukemorales/query-key-factory";

// entities
import type { UserType } from "@/entities/user/models/enums";
import type { RequestGetAcademyRegistrationRequestPayload } from "@/entities/academy-registration-request/domain/repository";

export const AcademyRegistrationRequestsQueryKeys = createQueryKeys(
    "academy_registration_requests",
    {
        lists: (params: RequestGetAcademyRegistrationRequestPayload) => [
            params.academyId,
            params.size,
            params.nextToken,
        ],
    },
);

export const AcademyRegistrationUserQueryKeys = createQueryKeys("academy_registration_user", {
    detail: (userId: string, userType: UserType) => [userId, userType],
    cancel: (id: string, academyId: string, userId: string) => [id, academyId, userId],
    approve: (id: string, academyId: string, userId: string) => [id, academyId, userId],
});

export const AcademyRegistrationRequestQueryKeys = mergeQueryKeys(
    AcademyRegistrationRequestsQueryKeys,
    AcademyRegistrationUserQueryKeys,
);
